<template>
    <div class="bg-primary px-4 py-2">
        <div class="flex justify-between items-center">
            <div>
                <router-link class="text-slate-700 text-2xl text-white" to="/">IT Event Management System</router-link>
            </div>
            <div>
                <button id="dropdownDefaultButton" data-dropdown-toggle="dropdown"
                    class="text-white font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center"
                    type="button">
                    {{ $root.organizer.name || '' }}
                    <svg class="w-2.5 h-2.5 ml-2.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none"
                        viewBox="0 0 10 6">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="m1 1 4 4 4-4" />
                    </svg></button>
                <!-- Dropdown menu -->
                <div id="dropdown"
                    class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow w-44 dark:bg-gray-700">
                    <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" aria-labelledby="dropdownDefaultButton">
                        <!-- <li>
                            <router-link
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                                to="/profile">Profile</router-link>
                        </li> -->
                        <li>
                            <a href="javascript:"
                                class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
                                @click="logout()">Logout</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { initFlowbite } from 'flowbite'
export default {
    mounted() {
        initFlowbite();
    },

    methods: {
        async logout() {
            const response = await this.$root.organizer.logout();
            if (response.result === 'success') {
                this.organizer = null;
                this.removeCredentials();
                window.location.reload();
            }
        }
    }
}
</script>